import * as React from 'react'
import MyPunchCouponType from '../MyPunchCouponType'
import * as Styles from './PunchCouponList.style'
import { classes } from 'typestyle'
import { TimeStream } from '../../../../utils/tools'

interface PunchCouponState {
    couponList: MyPunchCouponType.CouponList[],
    goMyCouponPage: (item: MyPunchCouponType.CouponList) => void | null
}

const regRule = /[0-9]{1,}/g

interface Statustest {
    couponColor: string,
    buttonText: string,
    textColor: string
}

export default class PunchCouponList extends React.Component<PunchCouponState> {
    public getCouponStatus = (item: MyPunchCouponType.CouponList) => {
        const couponStatus: Statustest = {
            couponColor: '',
            buttonText: '',
            textColor: ''
        }
        if (item.status === 'deadline') {
            couponStatus.couponColor = 'grey'
            couponStatus.textColor = 'grey'
            if (item.used) {
                couponStatus.buttonText = '已使用'
            } else {
                couponStatus.buttonText = '已过期'
            }
        } else if (item.status === 'unreceived') {
            if (item.used) {
                couponStatus.textColor = 'grey'
                couponStatus.couponColor = 'grey'
                couponStatus.buttonText = '已使用'
            } else {
                couponStatus.textColor = 'red'
                couponStatus.couponColor = 'red'
                couponStatus.buttonText = '立即领取'
            }
        } else {
            if (item.used) {
                couponStatus.textColor = 'grey'
                couponStatus.couponColor = 'grey'
                couponStatus.buttonText = '已使用'
            } else {
                couponStatus.textColor = 'red'
                couponStatus.couponColor = 'red'
                couponStatus.buttonText = '立即使用'
            }
        }
        return couponStatus
    }

    public render() {
        if (this.props.couponList.length === 0) {
            return null
        }
        return(
            <div>
                <div className={Styles.title}>
                    未兑换奖励
                </div>
            {this.props.couponList && this.props.couponList.length > 0 && this.props.couponList.map((item: MyPunchCouponType.CouponList, id: number) => (
               (<div className={Styles.punchCouponWrap} key={id} onClick={() => this.props.goMyCouponPage(item)}>
                    <div className={Styles.couponPriceActive}>
                        <div className={Styles.noUseCoupon}>
                        {this.getCouponStatus(item).couponColor === 'grey' ?
                            <img src="https://static-1253442168.image.myqcloud.com/picture/11169038_6711ed0847890ff528720cfd682c5a44.jpg"/>
                            :
                            <img src="https://static-1253442168.image.myqcloud.com/picture/11169038_bfca67aec0997fe296144dab371f7af5.jpg"/>
                        }
                            <div className={Styles.priceBox}>
                                <div className={Styles.couponPrice}>
                                    <span style={{fontSize: 20, fontWeight: 600, color: '#FFFFFF', lineHeight: '20px', marginBottom: '4px'}}>￥</span>
                                    {String(item.price / 100).split('.')[0]}
                                    {String(item.price / 100).split('.')[1] !== undefined ?
                                        <span className={Styles.decimalPrice}>.{String(item.price / 100).split('.')[1]}</span>
                                        : null
                                    }
                                </div>
                            </div>
                            <div className={Styles.couponTextBox}>
                                <div className={Styles.couponText}>
                                    <div className={classes(this.getCouponStatus(item).textColor === 'grey' ? Styles.usedCouponTitle : Styles.noUseCouponTitle)}>

                                        {item.bag_id ? `连续打卡${item.title.match(regRule)}天奖励` : `${item.title}`}
                                    </div>
                                    <div className={classes(this.getCouponStatus(item).textColor === 'grey' ? Styles.usedValidTime : Styles.noUsevalidTime)}>
                                        {item.bag_id ? `有效期至: ${TimeStream(item.deadline, 'CN_YMD_HM')}` : `有效期至: 永久有效`}
                                    </div>
                                </div>
                            </div>
                            <div className={Styles.clickButtonBox}>
                                <div className={classes(this.getCouponStatus(item).textColor === 'grey' ? Styles.usedClickButton : Styles.noUseClickButton)}>
                                    {this.getCouponStatus(item).buttonText}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>)))}
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/views/Punch/MyPunchCoupon/components/PunchCouponList.tsx